<lib-list-page
    [host]="this"
    title="Capabilities"
    icon="extension"
    searchPlaceholder="Search code or version…"
    [activeChips]="activeFilterChips()"
    (chipRemove)="removeFilterChip($event)"
    totalIcon="extension"
    totalLabel="Capabilities"
    emptyStateIcon="extension"
    emptyStateTitle="No capabilities match the current filter"
    emptyStateSubtitle="Capabilities show up here automatically when runners register their tasks via the tasksense.task.definition Kafka topic. Admins can also create drafts directly.">

    <ng-container actions>
        <button mat-flat-button color="primary" *ngIf="canManage()" (click)="openCreateDialog()">
            <mat-icon>add</mat-icon> New capability
        </button>
        <button mat-icon-button (click)="refreshData(true)" matTooltip="Refresh" aria-label="Refresh">
            <mat-icon>refresh</mat-icon>
        </button>
    </ng-container>

    <ng-container filters>
        <div class="filter-select-box">
            <div class="filter-context-label">
                <mat-icon class="filter-context-icon">flag</mat-icon>
                Status
                <span class="filter-active-count" *ngIf="filter().status !== 'ALL'">1</span>
            </div>
            <mat-form-field appearance="outline">
                <mat-select [value]="filter().status"
                            (selectionChange)="setStatusFilter($event.value)">
                    <mat-option *ngFor="let opt of statusOptions" [value]="opt.value">
                        {{ opt.label }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </ng-container>

    <table mat-table table [dataSource]="dataSource()" class="data-table" matSort (matSortChange)="sortData($event)">

        <ng-container matColumnDef="code">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="code" class="nowrap">Code</th>
            <td mat-cell *matCellDef="let c" class="nowrap">
                <a class="cap-code traversable" (click)="openDetail(c)">{{ c.code }}</a>
            </td>
        </ng-container>

        <ng-container matColumnDef="version">
            <th mat-header-cell *matHeaderCellDef class="nowrap">Version</th>
            <td mat-cell *matCellDef="let c" class="nowrap">
                <span class="cap-version">{{ c.version }}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="status" class="nowrap">Status</th>
            <td mat-cell *matCellDef="let c" class="nowrap">
                <span [class]="statusClass(c.status)">{{ c.status }}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef>Description</th>
            <td mat-cell *matCellDef="let c" class="nowrap">
                <span *ngIf="c.description">{{ c.description }}</span>
                <span *ngIf="!c.description" class="muted">—</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="createdBy">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="createdBy" class="nowrap">Created by</th>
            <td mat-cell *matCellDef="let c" class="nowrap">{{ c.createdBy }}</td>
        </ng-container>

        <ng-container matColumnDef="createdAt">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="createdAt" class="nowrap">Created</th>
            <td mat-cell *matCellDef="let c" class="nowrap">{{ c.createdAt | date:'medium' }}</td>
        </ng-container>

        <ng-container matColumnDef="actions" stickyEnd>
            <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
            <td mat-cell *matCellDef="let c" class="nowrap row-actions">
                <button mat-icon-button matTooltip="Promote to ACTIVE" aria-label="Promote to active"
                        *ngIf="canManage() && isInProgress(c)" (click)="promote(c)">
                    <mat-icon>publish</mat-icon>
                </button>
                <button mat-icon-button matTooltip="Delete draft" aria-label="Delete draft"
                        *ngIf="canManage() && isInProgress(c)" (click)="deleteDraft(c)">
                    <mat-icon>delete_outline</mat-icon>
                </button>
                <button mat-icon-button matTooltip="Deactivate" aria-label="Deactivate"
                        *ngIf="canManage() && isActive(c)" (click)="deactivate(c)">
                    <mat-icon>pause_circle</mat-icon>
                </button>
                <button mat-icon-button matTooltip="Decommission" aria-label="Decommission"
                        *ngIf="canManage() && isInactive(c)" (click)="decommission(c)">
                    <mat-icon>block</mat-icon>
                </button>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" class="selectable-table-row"></tr>
    </table>

</lib-list-page>
